import { ReactElement } from 'react';
import { Heading, useEntity, SubNav } from 'components';
import { NavLinkProps } from 'react-router-dom';
import { Enterprise } from 'modules/core/types';
import { platformAdmin, useHasPerm } from 'core/permissions';

export function Nav(): ReactElement {
  const {
    item: {
      external,
      company: { title },
    },
  } = useEntity<Enterprise>();
  const isPlatformAdmin = useHasPerm(platformAdmin);

  let nav: NavLinkProps[] = [];
  if (!external) {
    nav = [
      {
        to: '',
        end: true,
        children: 'Update',
      },
      {
        to: 'logos',
        children: 'Logos',
      },
      {
        to: 'planning',
        children: 'Planning',
      },
      {
        to: 'membership',
        children: 'Membership',
      },
      {
        to: 'membership_log',
        children: 'Membership log',
      },
      {
        to: 'onec',
        children: '1C Integration',
      },
    ];
    if (isPlatformAdmin) {
      nav.push({
        to: 'platform_config',
        children: 'Platform config',
      });
    }
  }

  return (
    <SubNav nav={nav}>
      <Heading className="flex-column">
        <h1>{title}</h1>
      </Heading>
    </SubNav>
  );
}
